import { cachePageInstances } from './page';
import { isSubRoute } from './utils';

declare const MAX_ROUTES: Record<string, string>;

export function clearPagesCache(route: string) {
  const deleted: string[] = Object.keys(MAX_ROUTES).filter((subRoute) => isSubRoute(route, subRoute)) ?? [];
  deleted.forEach((d) => {
    // 当前路由的页面缓存不可清空
    if (d === location.pathname.substring(1)) {
      return;
    }
    const pageCode = MAX_ROUTES[d];
    const pageInstance = cachePageInstances.get(pageCode);
    if (pageInstance) {
      // 销毁页面实例前先执行生命周期
      pageInstance.onUnload?.();
      cachePageInstances.delete(pageCode);
    }
  });
}
